var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNumber14SvgrepoCom = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "#ECECEC",
  viewBox: "-3.2 -3.2 38.40 38.40",
  stroke: "#ECECEC",
  strokeWidth: 0.00032,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_bgCarrier",
  strokeWidth: 0,
  transform: "translate(3.1999999999999993,3.1999999999999993), scale(0.8)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -3.2,
  y: -3.2,
  width: 38.4,
  height: 38.4,
  rx: 19.2,
  fill: "#7F7F7F",
  strokeWidth: 0
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_tracerCarrier",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_iconCarrier"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 3c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zM19.546 20.68c-0.839 1.137-2.003 1.705-3.492 1.705-1.19 0-2.16-0.319-2.911-0.959-0.75-0.641-1.199-1.502-1.346-2.582l2.469-0.256c0.070 0.559 0.278 1 0.623 1.324 0.345 0.326 0.742 0.488 1.192 0.488 0.515 0 0.949-0.209 1.307-0.627 0.355-0.418 0.534-1.049 0.534-1.893 0-0.79-0.178-1.383-0.532-1.778-0.355-0.395-0.818-0.593-1.388-0.593-0.71 0-1.348 0.312-1.911 0.938l-1.997-0.289 1.266-6.711h6.531v2.312h-4.658l-0.397 2.192c0.553-0.273 1.117-0.411 1.693-0.411 1.099 0 2.030 0.399 2.795 1.196s1.146 1.832 1.146 3.103c-0.001 1.062-0.309 2.009-0.924 2.841z"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNumber14SvgrepoCom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/number14-svgrepo-com.7281e43e.svg";
export { ForwardRef as ReactComponent };